import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective } from 'angular-datatables';
import { from, Subject } from 'rxjs';
import { LoaderComponent } from '../../servicios/loader/loader.component';
import { SeleccionService } from '../../servicios/seleccion.service';
import { ToolsService } from '../../recursos/tools.service';
import { AlertifyService } from 'src/app/recursos/alertify.service';
import { Router } from '@angular/router';
import { configuracion } from '../../recursos/config.service';

@Component({
  selector: 'app-encuesta-reporte',
  templateUrl: './encuesta-reporte.component.html',
  styleUrls: ['./encuesta-reporte.component.css']
})
export class EncuestaReporteComponent implements OnInit {

  public mr: NgbModalRef;
  @ViewChild(DataTableDirective)
  dtOptionsFicha: DataTables.Settings = {};
  public dtTriggerFicha: Subject<any>;

  public encabezado: string = ""; public nombreBeca: string = ""; public selectPeriodo: string = ''; public selectFacultad: string = '';
  public vecListaResponde = []; public vecPeriodo = []; vecFacultad = []; public vecRespOtro = [];

  constructor(private cargando: LoaderComponent, private srvSelect: SeleccionService, private tools: ToolsService, private confMensaje: configuracion,
    private modalService: NgbModal, private alerti: AlertifyService, private ruta: Router) { }

  ngOnInit() {
    this.dtTriggerFicha = new Subject<any>();
    this.dtOptionsFicha[0] = this.tools.OpcionesTabla(10);

    this.encabezado = "Lista de estudiantes postulantes";
    this.nombreBeca = localStorage.getItem('modNom');
    this.cargarPeriodos(); this.cargarFacultades();
  }
  //FUNCION QUE CARGA TODAS LOS PERIODOS ACADEMICOS DE LA INSTITUCION
  async cargarPeriodos() {
    this.vecPeriodo = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(3, "na", "na", "na").subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectPeriodo = res.carrera[0]['strCodigo'];
      for (let i in res.carrera) {
        this.vecPeriodo.push({
          codigo: res.carrera[i]['strCodigo'], descripcion: res.carrera[i]['strDescripcion'], inicio: res.carrera[i]['dtFechaInic'], fin: res.carrera[i]['dtFechaFin']
        });
      }
    }
  }
  //FUNCION QUE CARGA TODAS LAS FACULTADES DE LA INSTITUCION
  async cargarFacultades() {
    this.vecFacultad = [];
    const res = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(1, 'na', 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (res.success) {
      this.selectFacultad = res.carrera[0]['strCodigo'];
      this.vecFacultad = res.carrera;
    }
  }
  //ABRIR EL MODAL PARA ESCOGER EL PERIODO DE DE CONSULTA
  verFechasRespuesta(nameMod) {
    if (localStorage.getItem('modUser') == 'true') {
      //this.inicarParametro();
      this.mr = this.modalService.open(nameMod);
    }
    else
      this.alerti.error("Este perfil no tiene permiso para esta actividad");
  }
  //BUSCAR LAS FICHAS RESPONDIDAS EN EL PERIODO ACADEMICO
  async verResultados() {
    var table2 = $('#tblFichas').DataTable({
      destroy: true
    });
    table2.destroy();
    this.cerrarModal();
    this.cargando.abrir();
    this.vecListaResponde = [];

    const resCarrera = await new Promise<any>(resolve =>
      this.srvSelect.gestionCarreras(2, this.selectFacultad, 'na', 'na').subscribe(translated => {
        resolve(translated)
      }));
    if (resCarrera.success) {
      for (let objCarrera of resCarrera.carrera) {

        const resGrupo = await new Promise<any>(resolve =>
          this.srvSelect.gestionEncuesta(27, this.selectPeriodo, objCarrera.codCarrera, 'na', 'na').subscribe(translated => {
            resolve(translated)
          }));
        if (resGrupo.success) {

          for (let contRes in resGrupo.encuesta) {

            const resOtros = await new Promise<any>(resolve =>
              this.srvSelect.gestionEncuesta(28, resGrupo.encuesta[contRes]['intIdResponde'], 'na', 'na', 'na').subscribe(translated => {
                resolve(translated)
              }));
            this.vecRespOtro = resOtros.encuesta;

            const resOpcion = await new Promise<any>(resolve =>
              this.srvSelect.gestionEncuesta(17, resGrupo.encuesta[contRes]['intIdResponde'], 'na', 'na', 'na').subscribe(translated => {
                resolve(translated)
              }));
            if (resOpcion.success) {
              this.vecListaResponde.push({
                cedula: resGrupo.encuesta[contRes]['strCedEstudiante'],
                nombres: '', fnacimiento: '', provincia: '', canton: '', parroquia: '', sexo: '', telefono: '',
                correo: '', etnia: '', discapacidad: '', porcentaje: '', carnet: '', genero: ''
              });

              for (let objOp of resOpcion.encuesta) {
                if ((objOp.intGrupo == 1) && (objOp.intPregunta) == 1)
                  this.vecListaResponde[this.vecListaResponde.length - 1]['nombres'] = objOp.strRespuesta;
                if ((objOp.intGrupo == 1) && (objOp.intPregunta) == 2)
                  this.vecListaResponde[this.vecListaResponde.length - 1]['nombres'] += ' ' + objOp.strRespuesta;

                this.verRespuestasGenerales(objOp.intGrupo, objOp.intPregunta, 1, 10, 'fnacimiento', objOp.strRespuesta.split('T')[0], this.vecListaResponde.length - 1);

                this.verRespuestasGenerales(objOp.intGrupo, objOp.intOpcion, 1, 28, 'provincia', objOp.strRespuesta, this.vecListaResponde.length - 1);
                this.verRespuestasGenerales(objOp.intGrupo, objOp.intOpcion, 1, 29, 'canton', objOp.strRespuesta, this.vecListaResponde.length - 1);
                this.verRespuestasGenerales(objOp.intGrupo, objOp.intOpcion, 1, 30, 'parroquia', objOp.strRespuesta, this.vecListaResponde.length - 1);
                this.verRespuestasGenerales(objOp.intGrupo, objOp.intPregunta, 1, 11, 'sexo', objOp.strRespuesta == 1 ? 'Masculino' : 'Femenino', this.vecListaResponde.length - 1);

                this.verRespuestasGenerales(objOp.intGrupo, objOp.intOpcion, 1, 33, 'telefono', objOp.strRespuesta, this.vecListaResponde.length - 1);
                this.verRespuestasGenerales(objOp.intGrupo, objOp.intOpcion, 1, 12, 'correo', objOp.strRespuesta, this.vecListaResponde.length - 1);

                this.verRespuestasOpcion(objOp.intGrupo, objOp.intPregunta, 2, 38, 'etnia', objOp.strRespuesta, objOp.strOpcion, this.vecListaResponde.length - 1);
                this.verRespuestaOtros(objOp.intResponde, 55, 'discapacidad', this.vecListaResponde.length - 1, 1);
                this.verRespuestaOtros(objOp.intResponde, 55, 'porcentaje', this.vecListaResponde.length - 1, 10);
                this.verRespuestaOtros(objOp.intResponde, 55, 'carnet', this.vecListaResponde.length - 1, 11);

                this.verRespuestasOpcion(objOp.intGrupo, objOp.intPregunta, 1, 27, 'genero', objOp.strRespuesta, objOp.strOpcion, this.vecListaResponde.length - 1);

              }
            }
          }
        }
        else
          this.alerti.message('No se encntró información de encuestas registradas');
      }
    }
    this.dtTriggerFicha.next();
    this.cargando.cerrar();
  }
  //VER EL VALOR DADO A UNA RESPUESTA EN GENERAL
  verRespuestasGenerales(grupo, pregunta, op1, op2, vector, respuesta, pos) {
    if ((grupo == op1) && (pregunta) == op2)
      this.vecListaResponde[pos][vector] = respuesta;
  }
  //VER EL VALOR DADO A UNA OPCION DE RESPUESTA GENERAL
  verRespuestasOpcion(grupo, pregunta, op1, op2, vector, respuesta, opcion, pos) {
    if ((grupo == op1) && (pregunta) == op2)
      if (respuesta == 'true')
        this.vecListaResponde[pos][vector] = opcion;
  }
  //VER EL VALOR ASIGNADO A UNA RESPUESTA DE TIPO OTROS
  async verRespuestaOtros(respuesta, opcion, vector, posicion, op) {
    for (let objOtro of this.vecRespOtro) {
      if (op == 1) {
        if (objOtro.intRespuesta == respuesta && objOtro.intOpcion == opcion && objOtro.strValorResp == 'true')
          this.vecListaResponde[posicion][vector] = objOtro.strNombre;
      }
      else {
        if (objOtro.intRespuesta == respuesta && objOtro.intOpcion == opcion && objOtro.intOtro == op) {
          this.vecListaResponde[posicion][vector] = objOtro.strValorResp;
        }
      }
    }
  }
  //FUNCION QUE ABRA LAS RESPUESTAS DE UNA FICHA SELECCIONADA
  verRespuesta(objFicha) {
    localStorage.setItem('localVerResp', objFicha.intIdResponde);
    this.ruta.navigate(["/gestion/verRespuestaFicha"]);
  }
  //FUNCION PARA CERRAR UN MODAL
  cerrarModal() {
    this.mr.close();
  }
}
